import { render, staticRenderFns } from "./LeadInventory.vue?vue&type=template&id=736b1487&"
import script from "./LeadInventory.vue?vue&type=script&lang=js&"
export * from "./LeadInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports